import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Sidebar from "components/Common/SideBar/SideBar";
import Header from "components/Common/Header/Header";
import { Paper, Box, Tabs, Tab, Typography, Button } from "@mui/material";
import classes from "./BulkEditHeaderV2.module.css";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import BackdropComponent from "components/Spinner/Spinner";
import SnackBar from "../../components/SnackBar/SnackBar";
import DialogBox from "../../components/DialogBox/DialogBoxuUnsavedChanges";
import AttendaceV2 from "components/BulkEdit/Attendance/AttendanceV2";
import EmployeeData from "components/BulkEdit/EmployeeData/EmployeeData";
import ACCV2 from "components/BulkEdit/ACC/ACCV2";
import TCIV2 from "components/BulkEdit/TCI/TCIV2";
import TicketEquipmentV2 from "components/BulkEdit/TicketsEquipment/TicketEquipmentV2";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { bulkEditStoreAction } from "../../Store/BulkEdit";
import {
  getBulkAttendance,
  searchClassRosterDetails,
} from "../../services/userServices";
import StatusDisposition from "components/BulkEdit/StatusDisposition/StatusDispositionOverrideV2";
import MilestonesV2 from "components/BulkEdit/Milestones/MilestonesV2";
import ClassData from "components/BulkEdit/Class/ClassData";

const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  marginLeft: "16px",
  marginTop: "16px",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

const BulkEditHeaderV2 = (props) => {
  const { t } = useTranslation(["bulkEditHeader"]);
  let navigate = useNavigate();

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [dialog, setDialog] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();

  const classTraineeId = useSelector((state) => state.bulkEdit);
  const [rosterDetails, setRosterDetails] = useState(null);
  const { roasterId } = useParams();
  const [traineeStatus, setTraineeStatus] = useState("ALL");
  const [option, setOption] = useState("Attendance");
  const [proceedOption, setProceedOption] = useState();
  const [cancelOption, setCancelOption] = useState();

  const [loading, setLoading] = useState(false);
  const [resetStatus, setResetStatus] = useState(false);
  const [loadData, setLoadData] = useState(false);

  const traineeStatusFilterHandler = (event) => {
    setLoading(true);
    setTraineeStatus(event.target.value);
  };
  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const dialogBoxReset = () => {
    setDialog({
      open: false,
      message: "",
    });
  };

  const handleProceed = (proceedOption) => {
    setOption(proceedOption);
  };
  const handleCancel = (cancelOption) => {
    setOption(cancelOption); // considering user is on same page
    dispatch(bulkEditStoreAction.setPreviousTabName(cancelOption));
  };

  const unsavedChangesWarning = (cancelOption) => {
    setDialog({
      open: true,
      message: t("message"),
    });
    setLoading(false);
    if (cancelOption) {
      setCancelOption(cancelOption);
    } else {
      setCancelOption("Attendance"); // default page is attendance
    }
  };
  const bulkEditStoreData = useSelector((state) => state.bulkEdit);

  const closeLoader = () => {
    setLoading(false);
  };
  const reset = () => {
    setResetStatus(false);
  };

  const optionChangeHandler = (event, option) => {
    dispatch(bulkEditStoreAction.setPreviousTabName(option));

    setTraineeStatus("ALL");
    setProceedOption(option);

    let currentTabData, allTabData;
    switch (bulkEditStoreData?.previousTabName) {
      case "Attendance":
        currentTabData = bulkEditStoreData?.storedAttendanceData;
        allTabData = bulkEditStoreData?.storedAttendanceAllData;
        break;
      case "Employee Data":
        currentTabData = bulkEditStoreData?.storedEmployeeData;
        allTabData = bulkEditStoreData?.storedEmployeeAllData;
        break;
      case "Class Data":
        currentTabData = bulkEditStoreData?.storedClassData;
        allTabData = bulkEditStoreData?.storedClassAllData;
        break;
      case "Status/Disposition (and Override)":
        currentTabData = bulkEditStoreData?.storedStatusDispositionData;
        allTabData = bulkEditStoreData?.storedStatusDispositionAllData;
        break;
      case "ACC":
        currentTabData = bulkEditStoreData?.storedAccData;
        allTabData = bulkEditStoreData?.storedAccAllData;
        break;
      case "TCI":
        currentTabData = bulkEditStoreData?.storedTciData;
        allTabData = bulkEditStoreData?.storedTciAllData;
        break;
      case "Milestones":
        currentTabData = bulkEditStoreData?.storedMilestoneData;
        allTabData = bulkEditStoreData?.storedMilestoneAllData;
        break;
      default:
        currentTabData = bulkEditStoreData?.storedAttendanceData;
        allTabData = bulkEditStoreData?.storedAttendanceAllData;
        if (JSON.stringify(currentTabData) !== JSON.stringify(allTabData)) {
          unsavedChangesWarning(bulkEditStoreData.previousTabName);
        } else {
          setOption(option);
        }
        break;
    }
    if (
      currentTabData !== null &&
      JSON.stringify(currentTabData) !== JSON.stringify(allTabData)
    ) {
      unsavedChangesWarning(bulkEditStoreData.previousTabName);
    } else {
      setOption(option);
    }
  };

  const resetFilter = () => {
    setResetStatus(true);
  };
  const options = [
    "Attendance",
    "Employee Data",
    "Class Data",
    "Status/Disposition (and Override)",
    "ACC",
    "TCI",
    "Ticket & Equipment",
    "Milestones",
  ];

  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      if (classTraineeId.traineeDetails.length > 0) {
        setLoadData(true);

        const dropdownData = classTraineeId.traineeDetails.map(
          (item) => item.traineeStatus,
        );
        const filter = ["ALL", ...new Set(dropdownData)];

        if (!cancelled) {
          setFilterData(filter);
        }

        try {
          await fetchData(
            bulkEditStoreData?.classRequestId,
            bulkEditStoreData?.classRosterId,
          );
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch data:", error);
          }
        }
      } else {
        navigate(-1);
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);
  const fetchData = async (classRequestId, classRosterId) => {
    setLoading(true);

    try {
      const response = await searchClassRosterDetails(
        classRequestId,
        classRosterId,
      );

      if (response?.message === "Success") {
        if (response?.data?.length > 0) {
          setRosterDetails(response?.data[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching class roster details:", error);
    } finally {
      setLoading(false);
    }
  };

  //Done to update filter status dropdown on changing the status in status disposition
  const updateFilterStatusList = async () => {
    let obj = {
      classTraineeIdList: classTraineeId.traineeDetails,
    };

    //to get the status of the selected trainees
    const response = await getBulkAttendance(obj);
    if (response.message === "Success") {
      setFilterData([
        "ALL",
        ...new Set(response.data.map((item) => item.TraineeStatus)),
      ]);
    } else {
      setSnack({
        open: true,
        message: "Failed to update trainee filter Status Data",
        severity: "error",
      });
    }
  };

  return (
    <Grid container spacing={2} className={classes.bulkEditHeaderV2Body}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={0} type="bulkEditV2" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        <Header title="ASTT" logoURL="/home" version="new" />

        {/* Main Content */}
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
            p: 2,
            height: "calc(100vh - 80px)",
            width: "calc(100vw - 110px)",
            mt: 1,
            ml: 2,
          }}
        >
          {/*Content Starts here */}
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={1}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  fontSize={12}
                  letterSpacing={0.1}
                  pb={0.75}
                >
                  {t("roster_id")}
                </Typography>
                <Typography variant="body2" fontSize={14}>
                  {props.rosterId}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  fontSize={12}
                  letterSpacing={0.1}
                  pb={0.75}
                >
                  {t("wave")}
                </Typography>
                <Typography variant="body2" fontSize={14}>
                  {rosterDetails?.Wave}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  fontSize={12}
                  letterSpacing={0.1}
                  pb={0.75}
                >
                  {t("project")}
                </Typography>
                <Typography variant="body2" fontSize={14}>
                  {rosterDetails?.ProjectName}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    fontSize={12}
                    letterSpacing={0.1}
                    pb={0.5}
                    pr={14}
                  >
                    {t("filterStatus")}
                  </Typography>
                  <FormControl
                    sx={{
                      width: 180,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                      "& .MuiSelect-select": {
                        padding: "10px 14px",
                      },
                    }}
                    size="small"
                  >
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={traineeStatus}
                      onChange={traineeStatusFilterHandler}
                    >
                      {filterData.map((item, i) => (
                        <MenuItem value={item} key={`${item}-${i}`}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <CustomOutlinedButton variant="outlined" onClick={resetFilter}>
                  {t("reset")}
                </CustomOutlinedButton>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Tabs
              value={option}
              onChange={optionChangeHandler}
              aria-label={t("aria-label.simple_tabs_example")}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "#3299FF",
                  height: "5px",
                },
              }}
              sx={{
                "& .MuiTab-root": {
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#3F5765",
                  letterSpacing: "0.10em",
                  textTransform: "none",
                  minWidth: "auto",
                  "&.Mui-selected": {
                    color: "#3299FF",
                  },
                  "&:hover": {
                    color: "#3299FF",
                  },
                },
              }}
            >
              {options.map((item, i) => (
                <Tab
                  value={item}
                  label={item}
                  tabIndex={i}
                  key={`${item}-${i}`}
                />
              ))}
            </Tabs>

            {loading ? <BackdropComponent /> : null}
            {loadData && (
              <>
                {option === "Attendance" && (
                  <AttendaceV2
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}

                {option === "Employee Data" && (
                  <EmployeeData
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
                {option === "Class Data" && (
                  <ClassData
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
                {option === "Status/Disposition (and Override)" && (
                  <StatusDisposition
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                    updateFilterStatusList={updateFilterStatusList}
                  />
                )}
                {option === "ACC" && (
                  <ACCV2
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
                {option === "TCI" && (
                  <TCIV2
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
                {option === "Ticket & Equipment" && (
                  <TicketEquipmentV2
                    roster={props.rosterId}
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
                {option === "Milestones" && (
                  <MilestonesV2
                    filterStatus={traineeStatus}
                    resetStatus={resetStatus}
                    onChange={reset}
                    closeLoader={closeLoader}
                  />
                )}
              </>
            )}
            <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
            {/* {Need to change color as per new design.. work is pending.} */}
            <DialogBox
              dialog={dialog}
              proceedOption={proceedOption}
              cancelOption={cancelOption}
              handleCancel={handleCancel}
              dialogBoxReset={dialogBoxReset}
              handleProceed={handleProceed}
            ></DialogBox>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default BulkEditHeaderV2;
